export enum ServiceBookItemType {
    EventItem,
    Twenty47Request,
    SiteServiceRequest
}